import chatMixin from "../../../mixins/chats";
import UserAvatar from '@/components/UserAvatar';

export default {
  name: "SearchResult",
  mixins: [
    chatMixin
  ],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    selectedResult: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    UserAvatar
  },
  methods: {
    selectConversation() {
      this.selectedResult(this.item);
    }
  }
};
